import "./style.css";
import logotipo from "../../../imagens/logo.svg";
import { useEffect, useRef, useState } from "react";
import { Features } from "./Features";
import { Banner } from "./Banner";
import { SobreEmpresa } from "./SobreEmpresa";

export function HomeComponentZapMei() {
    const component2Ref = useRef(null);
    const component1Ref = useRef(null);
    const component3Ref = useRef(null);

    const component4Ref = useRef(null);

    const [isVisible, setIsVisible] = useState(false);
    const [isHiddenBanner, setIsHiddenBanner] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    // Exemplo de como deve estar a lógica de scroll no pai
useEffect(() => {
    const handleScroll = () => {
        if (window.scrollY > 200) {
            setIsHiddenBanner(true);
        } else {
            setIsHiddenBanner(false); // ISSO garante que ele volte ao subir
        }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
}, []);




    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Quando o Features entra na tela
                        setIsVisible(true);
                        setIsHiddenBanner(true);
                    } else {
                        // Quando o Features sai da tela
                        // Se o topo do componente está abaixo de 0, 
                        // significa que ele saiu pela parte de baixo da tela (usuário subiu)
                        if (entry.boundingClientRect.top > 0) {
                            setIsVisible(false); // Reseta animação do Features
                            setIsHiddenBanner(false); // Mostra o Banner novamente
                        }
                    }
                });
            },
            {
                threshold: 0.05, // Dispara com apenas 5% de visibilidade
                rootMargin: "0px 0px -50px 0px" // "Gordura" para disparar um pouco antes
            }
        );

        if (component2Ref.current) {
            observer.observe(component2Ref.current);
        }

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        window.scroll(0, 0);
    }, [])


    const scrollToSobre = (e) => {
        e.preventDefault(); // Evita o comportamento padrão do link
        component4Ref.current?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            <div style={{ background: "#000", width: "100%" }}>
                <div style={{ margin: "0 auto" }}>
                    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
                        <a href="https://www.meucontadoronline.com.br/">
                            <div className="logo">
                                <img
                                    src={logotipo}
                                    alt="Logo"
                                    fetchpriority="high"
                                    width="224"
                                    height="65"
                                />
                            </div>
                        </a>
                    </header>

                    <div className="container">

                        {/* COMPONENT-1 com animação */}
                        <Banner
                            component1Ref={component1Ref}
                            isHiddenBanner={isHiddenBanner}
                            scrollToSobre={scrollToSobre}
                        />

                        {/* COMPONENT-2 com animação */}
                        <Features
                            component2Ref={component2Ref}
                            component4Ref={component4Ref}
                            isVisible={isVisible}
                        />

                        {/* COMPONENT-3 com animação */}
                        <SobreEmpresa
                            component2Ref={component3Ref}
                            isVisible={isVisible}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
